import { encountersJSON, pkmJSON, WaitFetch } from "./helper.js";
import { StoredEncounter } from "./interfaces.js";

var MyEncs: Record<string, StoredEncounter> = {};

$(window).on("load", async function () {
	await WaitFetch();
	InitEncounterList();
	InitInteractions();
	InitStorage();
});

function InitEncounterList() {
	Object.entries(encountersJSON!).forEach(([routeName, routeInfo]) => {
		let $encDropdown = $(`<div>`, { class: "encDropdown" });

		Object.entries(routeInfo.Sections).forEach(([sectionName, sectionInfo]) => {
			let $encounters = $(`<div>`, { class: "encList" });

			sectionInfo.Encounters.forEach((enc, idx) => {
				let $enc = $(`<div>`, { class: `encounter ${idx == sectionInfo.Encounters.length - 1 ? "last" : ""}` })
					.append($(`<p>`, { class: "perc", text: `${enc.Percentage}%` }))
					.append($(`<img>`, { src: `/images/pkm/icons/png/${pkmJSON![enc.Pokemon].SpeciesIdx}.png` }))
					.append($(`<p>`, { class: "pkm", text: `${enc.Pokemon}${enc.Forme != "" ? `-${enc.Forme}` : ""}` }));

				$encounters.append($enc);
			});

			let revisedSectionName = sectionName;

			if (sectionName == "1F, B1F" || sectionName == "B2F, Passage" ||
					sectionName == "1F, 2F, 3F" || sectionName == "Ice Rock Room" ||
					sectionName == "1F, B1F, B2F" || sectionName == "Small Room 1, 2")
				revisedSectionName = "cave";

			let $section = $(`<div>`, { class: `encSection ${revisedSectionName.replaceAll(" ", "").toLowerCase()}` })
				.append($(`<h5>`, { text: `${sectionName} (${sectionInfo.Level})` }))
				.append($encounters);

			$encDropdown.append($section);
		});

		let $route = $(`<div>`, { class: "route" })
			.append($(`<div>`, { class: "routeNameBlock" })
				.append($(`<h4>`, { text: routeName }))
				.append($(`<div>`, { class: "routeIcons" })
					.append('<svg class="traded" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Traded Away</title><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 19L3 16M3 16L6 13M3 16H11C12.6569 16 14 14.6569 14 13V12M10 12V11C10 9.34315 11.3431 8 13 8H21M21 8L18 11M21 8L18 5" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>')
					.append('<svg version="1.1" id="_x32_" class="killed" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64px" height="64px" viewBox="0 0 512 512" xml:space="preserve" fill="#ffffff"><title>Killed</title><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css">  .st0{fill:#ffffff;}  </style> <g> <path class="st0" d="M437.914,74.078C392.43,27,326.117,0,255.992,0C185.883,0,119.57,27,74.102,74.063 c-42.5,44-64.703,102.828-62.531,165.688l6.609,83.875c6.031,84.75,55.234,93.906,76.094,93.906c7.563,0,15.531-1.094,23.625-3.188 c1.094,7.938,1,21.859,0.922,32.688l-0.078,15.063c-0.141,10.938-0.359,27.5,11.234,39.234c4.797,4.875,13.563,10.672,28,10.672 h196.047c14.438,0,23.188-5.797,28-10.656c11.578-11.75,11.375-28.297,11.234-39.25l-0.094-15.031 c-0.063-10.844-0.172-24.781,0.938-32.719c8.172,2.109,16.094,3.188,23.625,3.188c20.859,0,70.047-9.156,76.094-93.75l6.563-83.156 l0.047-0.875C502.602,176.891,480.398,118.063,437.914,74.078z M459.961,237.906l-6.516,82.844 c-2.672,37.344-14.703,56.281-35.719,56.281c-4.844,0-10.266-0.891-16.297-2.688c-14.406-4.156-26.891-1.375-35.703,7.5 c-13.406,13.5-13.266,35.313-13.047,65.5l0.078,15.281c0.031,2.5,0.078,6.188-0.141,8.875h-42.75v-50.016h-32.406V471.5h-42.938 v-50.016h-32.391V471.5h-42.766c-0.203-2.688-0.156-6.375-0.125-8.906l0.078-15.297c0.219-30.156,0.359-51.953-13.047-65.453 c-8.766-8.844-20.953-11.75-35.875-7.453c-5.859,1.75-11.281,2.641-16.125,2.641c-21.031,0-33.031-18.938-35.719-56.438 l-6.531-82.688c-1.656-51.609,16.5-99.781,51.203-135.688C141.117,63,196.805,40.5,255.992,40.5 c59.203,0,114.891,22.5,152.781,61.719C443.477,138.125,461.648,186.297,459.961,237.906z"></path> <path class="st0" d="M256.008,309.656c-9.719,0-31.125,46.688-35.031,54.469c-3.875,7.781,3.906,19.469,15.578,15.563 c11.672-3.875,19.453-13.609,19.453-13.609s7.781,9.734,19.453,13.609c11.656,3.906,19.453-7.781,15.563-15.563 C287.117,356.344,265.742,309.656,256.008,309.656z"></path> <path class="st0" d="M171.586,183.281c-30.891-3.25-58.578,19.188-61.828,50.094l-4.188,29.422 c-3.25,30.922,19.188,58.578,50.078,61.828c30.922,3.25,58.609-19.172,61.844-50.094l4.188-29.422 C224.914,214.188,202.508,186.531,171.586,183.281z"></path> <path class="st0" d="M402.242,233.375c-3.234-30.906-30.938-53.344-61.828-50.094c-30.922,3.25-53.328,30.906-50.094,61.828 l4.172,29.422c3.25,30.922,30.938,53.344,61.844,50.094s53.344-30.906,50.094-61.828L402.242,233.375z"></path> </g> </g></svg>')
					.append('<svg class="reset" width="64px" height="64px" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><title>Reset</title><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><defs><style>.cls-1{fill:none;stroke:#ff0000;stroke-miterlimit:10;stroke-width:1.91px;}</style></defs><circle class="cls-1" cx="12" cy="12" r="10.5"></circle><line class="cls-1" x1="19.64" y1="4.36" x2="4.36" y2="19.64"></line></g></svg>')
				)
			)
			.append($(`<div>`, { class: "encBlock" })
				.append($(`<div>`, { class: "encSlot nye" })
					.append($(`<p>`, { text: "-- Not Yet Encountered --" })))
				.append($encDropdown)
			);

		$("#routeList").append($route);
	});
}

function InitInteractions() {
	$(".encSlot").on("click", function () {
		let $dropdown = $(this).siblings(".encDropdown");
		let notOpen = $dropdown.css("display") == "none";

		$(".encDropdown").css("display", "none");
	
		$dropdown.css("display", notOpen ? "flex" : "none");

		let leftSide = $dropdown.siblings(".encSlot").offset()!.left;
		let dropdownWidth = $dropdown.innerWidth()!;
		
		if (leftSide + dropdownWidth > $(window).width()!) {
			$dropdown.css("right", "0px");
		}
	});

	$("svg.traded").on("click", function () {
		let $encSlot = $(this).closest(".routeNameBlock").siblings(".encBlock").children(".encSlot");
		let routeName = $(this).closest(".routeNameBlock").children("h4").text();

		if (!MyEncs[routeName] || MyEncs[routeName]?.Type == "killed")
			return;

		let pkmName = MyEncs[routeName].Pokemon;

		$encSlot.html("");
		$encSlot.append($(`<img>`, { src: `/images/pkm/icons/png/${pkmJSON![pkmName].SpeciesIdx}.png` }));
		$encSlot.append($(`<p>`, { text: pkmName, style: "text-decoration: line-through;" }));
		$encSlot.append($(`<p>`, { text: "(Traded Away)" }));

		$(".encDropdown").css("display", "none");
		MyEncs[routeName].TradedAway = true;

		localStorage.setItem("MyEncounters", JSON.stringify(MyEncs));
	});

	$("svg.killed").on("click", function () {
		let $encSlot = $(this).closest(".routeNameBlock").siblings(".encBlock").children(".encSlot");

		$encSlot.attr("class", "encSlot killed");

		$encSlot.html("");
		$encSlot.append($(`<p>`, { text: "Accidents Happen" }));

		$(".encDropdown").css("display", "none");

		let routeName = $(this).closest(".routeNameBlock").children("h4").text();
		MyEncs[routeName] = {
			Pokemon: "Accidents Happen",
			Type: "killed",
			TradedAway: false
		}

		localStorage.setItem("MyEncounters", JSON.stringify(MyEncs));
	});

	$("svg.reset").on("click", function () {
		let $encSlot = $(this).closest(".routeNameBlock").siblings(".encBlock").children(".encSlot");

		$encSlot.attr("class", "encSlot nye");

		$encSlot.html("");
		$encSlot.append($(`<p>`, { text: "-- Not Yet Encountered --" }));

		$(".encDropdown").css("display", "none");

		let routeName = $(this).closest(".routeNameBlock").children("h4").text();
		delete MyEncs[routeName];

		localStorage.setItem("MyEncounters", JSON.stringify(MyEncs));
	});

	$(".encounter").on("click", function () {
		let $encSlot = $(this).closest(".encDropdown").siblings(".encSlot");
		let pkmName = $(this).children(".pkm").text();

		let sectionType = $(this).closest(".encSection").attr("class")!.split(/\s+/);
		sectionType = sectionType.filter(cls => cls != "encSection");

		$encSlot.attr("class", `encSlot ${sectionType}`);

		$encSlot.html("");
		$encSlot.append($(`<img>`, { src: `/images/pkm/icons/png/${pkmJSON![pkmName].SpeciesIdx}.png` }));
		$encSlot.append($(`<p>`, { text: pkmName }));

		$(".encDropdown").css("display", "none");

		let routeName = $(this).closest(".encBlock").siblings(".routeNameBlock").children("h4").text();
		MyEncs[routeName] = {
			Pokemon: pkmName,
			Type: sectionType[0],
			TradedAway: false
		}

		localStorage.setItem("MyEncounters", JSON.stringify(MyEncs));
	});

	$("#resetAll").on("click", function () {
		if (window.confirm(`Are you sure you want to reset all of your encounters?`)) {
			MyEncs = {};
			localStorage.setItem("MyEncounters", JSON.stringify(MyEncs));

			let $encSlots = $(".encSlot");
			$encSlots.attr("class", "encSlot nye");

			$encSlots.html("");
			$encSlots.append($(`<p>`, { text: "-- Not Yet Encountered --" }));
		}
	});
}

function InitStorage() {
	if (localStorage.getItem("MyEncounters")) {
		MyEncs = JSON.parse(localStorage.getItem("MyEncounters")!);

		Object.entries(MyEncs).forEach(([route, encInfo]) => {
			let $encSlot = $(".routeNameBlock h4").filter(function () {
				return $(this).text() == route;
			}).closest(".route").find(".encSlot");

			$encSlot.attr("class", `encSlot ${encInfo.Type}`);

			if (encInfo.Pokemon == "Accidents Happen") {
				$encSlot.html("");
				$encSlot.append($(`<p>`, { text: "Accidents Happen" }));
			}
			else if (encInfo.TradedAway) {
				$encSlot.html("");
				$encSlot.append($(`<img>`, { src: `/images/pkm/icons/png/${pkmJSON![encInfo.Pokemon].SpeciesIdx}.png` }));
				$encSlot.append($(`<p>`, { text: encInfo.Pokemon, style: "text-decoration: line-through;" }));
				$encSlot.append($(`<p>`, { text: "(Traded Away)" }));
			}
			else {
				$encSlot.html("");
				$encSlot.append($(`<img>`, { src: `/images/pkm/icons/png/${pkmJSON![encInfo.Pokemon].SpeciesIdx}.png` }));
				$encSlot.append($(`<p>`, { text: encInfo.Pokemon }));
			}
		});
	}
}